
/**
 * Enumeration representing special symbols in IO.
 */
enum Symbols {
  CURLY_OPEN      = '{',
  CURLY_CLOSE     = '}',
  BRACKET_OPEN    = '[',
  BRACKET_CLOSE   = ']',
  COLON           = ':',
  COMMA           = ',',
  HASH            = '#',
  DOUBLE_QUOTE    = '"',
  SINGLE_QUOTE    = "'",
  BACKSLASH       = "\\",
  TILDE           = '~',
  PLUS            = '+',
  MINUS           = '-',
  DOLLAR          = '$',
  DOT             = '.',
}

export default Symbols;